import { ReactNode } from "react";
import { AppWordmark } from "@archlang/app-shell/editor";

// Centered card layout shared by sign-in, sign-up, and accept-invite pages
// (shown when the viewer is signed out).
export function AuthShell({ children }: { readonly children: ReactNode }) {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-slate-950 px-4">
      {/* Ambient glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(50rem_30rem_at_50%_-5%,rgba(56,189,248,0.12),transparent)]"
      />

      {/* Wordmark — the first screen every Studio user meets, so it is drawn by
          the shared component rather than re-composed here. */}
      <div className="relative mb-8 flex items-center gap-2.5" data-testid="wordmark">
        <AppWordmark tagline="Studio" size="lg" />
      </div>

      {/* Card */}
      <main className="relative w-full max-w-sm rounded-2xl border border-slate-800 bg-slate-900/80 p-8 shadow-2xl shadow-black/40 backdrop-blur-sm">
        {children}
      </main>

      <p className="relative mt-6 text-xs text-slate-600">
        Architecture, versioned as code.
      </p>
    </div>
  );
}
